export default __webpack_public_path__ + "static/binary-a2c7ad91e5c52a4d15ea28066ac8630e.png";